import {
  Box,
  Divider,
  FormControl,
  Grid,
  MenuItem,
  Typography,
} from "@mui/material";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { SearchFilter } from "../../common/components/functional/FilterSearchField/FilterSearchField";
import { CenteredGridItem } from "../../common/components/functional/FilterSearchField/styled";
import {
  RoundedButton,
  SelectLight,
} from "../../common/components/styled/styled";
import { Controller, FormProvider, useForm } from "react-hook-form";
import { SalaryFilters } from "./SalaryFilters";
import {
  TYPE_EMPLOYER_HEALTH_INSURANCE_REDUCTION,
  TYPE_PAYSLIP,
  TYPE_WAGE_REPORT,
  TYPES,
} from "./constants";
import { EmployerHealthInsuranceReductionFilters } from "./employerHealthInsuranceReduction/Filters";
import {
  buildSalaryFilters,
  DEFAULT_SALARY_FORM,
  parseSalaryFilters,
  SalaryFilterFormTypes,
} from "./filters/common";

interface Props {
  filters: SearchFilter[];
  updateFilters: (filters: any) => void;
  handleMenuToggle: () => void;
}

export const MainFilters = ({
  filters,
  updateFilters,
  handleMenuToggle,
}: Props) => {
  const { t } = useTranslation();

  const methods = useForm<SalaryFilterFormTypes>({
    defaultValues: DEFAULT_SALARY_FORM,
    mode: "onChange",
  });

  const { watch, getValues, reset } = methods;
  const type = watch("type");

  useEffect(() => {
    reset(parseSalaryFilters(filters));
  }, [filters, reset]);

  const resetFilters = (type: string) => {
    reset({ ...DEFAULT_SALARY_FORM, type });
  };

  // Not using handleSubmit on purpose: the 'required' rule on yearMonth in the
  // reduction filters has never blocked searching
  const sendFilters = () => {
    handleMenuToggle();
    updateFilters(buildSalaryFilters(getValues(), t));
  };

  return (
    <Box sx={{ marginTop: "20px" }}>
      <Grid container spacing={4}>
        <CenteredGridItem item container spacing={2} xs={12}>
          <Grid item xs={12}>
            <FormProvider {...methods}>
              <CenteredGridItem item container spacing={2} xs={12}>
                <Grid item xs={4}>
                  <Typography align="right">{t("payslips:type")}</Typography>
                </Grid>
                <Grid item xs={8}>
                  <Controller
                    name="type"
                    control={methods.control}
                    render={({ field }) => (
                      <FormControl fullWidth size="small">
                        <SelectLight
                          value={field.value}
                          label={null}
                          onChange={(event) => {
                            resetFilters(event.target.value as string);
                          }}
                        >
                          {TYPES.map((type) => (
                            <MenuItem value={type.value} key={type.value}>
                              {t(`payslips:${type.name}`)}
                            </MenuItem>
                          ))}
                        </SelectLight>
                      </FormControl>
                    )}
                  />
                </Grid>
              </CenteredGridItem>
              <Divider sx={{ margin: "12px 0px" }} />
              {type === TYPE_PAYSLIP || type === TYPE_WAGE_REPORT ? (
                <SalaryFilters />
              ) : type === TYPE_EMPLOYER_HEALTH_INSURANCE_REDUCTION ? (
                <EmployerHealthInsuranceReductionFilters />
              ) : null}
            </FormProvider>
            <RoundedButton variant="contained" onClick={sendFilters}>
              {t("search")}
            </RoundedButton>
          </Grid>
        </CenteredGridItem>
      </Grid>
    </Box>
  );
};
